<template>
  <vx-card no-shadow>

    <h2 class="mb-6">User - General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Name</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input v-if="user" class="w-full" v-model="user.firstName" placeholder="First Name" />
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input v-if="user" class="w-full" v-model="user.lastName" placeholder="Last Name" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>SSN:</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input v-if="user" class="w-full" v-model="user.ssn" placeholder="Social Security Number" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Contact</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>E-mail:</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input v-if="user" class="w-full" v-model="user.email" type="email" placeholder="Email" />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Phone</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full" style="display:flex;align-items: flex-end;">
        <vs-select v-if="user" class="mt-2" v-model="user.phoneCountryCode">
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in phoneCountryCodes" />
        </vs-select>

        <vs-input v-if="user" v-validate="'numeric'" name="phone" v-model="user.phone" placeholder="Phone..." class="w-full ml-2" />
      </div>
    </div>

    <div class="vx-row  mb-6">
      <div class="vx-col sm:w-1/5 w-full">
      </div>
      <div class="vx-col sm:w-2/5 w-full" style="display:flex;align-items: flex-end;">
        <div class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</div>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Job Title</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input v-if="user" class="w-full" v-model="user.jobTitle" placeholder="Job title..." />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Permissions</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Role</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <div v-if="user" class="horizontal-row">
          <vs-button
            v-for="(role) in roles"
            :key="role.id"
            @click="onChangeRole(role.id)"
            :color="user.role == role.id ? 'success' : 'rgb(80, 80, 80)'"
            :type="user.role == role.id ? 'filled' : 'border'"
            icon-pack="feather"
            :icon="user.role == role.id ? 'icon-check' : ''"
            class="mr-3 selection-button"
          >{{role.label}}</vs-button>
        </div>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
      <span>Tags</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips class="tags" color="rgb(145, 32, 159)" placeholder="New Tag" v-model="tags">
          <vs-chip
            :key="tag"
            @click="removeTag(tag)"
            v-for="tag in tags" closable>
            {{ tag }}
          </vs-chip>
        </vs-chips>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Danger Zone</h5>
    </div>

    <div v-if="user" class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
      </div>
      <div class="vx-col sm:w-2/5 w-full" style="display:flex;align-items: flex-end;">
        <vs-button v-if="user.isDeactivated === false" @click="openConfirmDeactivateUser" color="warning" id="toggle-deactivate-user-button" class="mt-2">Deactivate User</vs-button>
        <span v-if="user.isDeactivated === true">User is deactivated. You can still update the user profile, but the user will not be able to login.</span>
        <vs-button v-if="user.isDeactivated === true" @click="activateUser" color="primary" id="toggle-activate-user-button" class="mt-2">Invite User</vs-button>
      </div>
    </div>

    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>

export default {
  data () {
    return {
      activeConfirmDeactivateUser: false,

      tags: [],

      user: null,

      roles: [
        {
          id: 0,
          label: "User"
        },
        {
          id: 1,
          label: "Admin"
        },
        {
          id: 2,
          label: "Venue Admin"
        }
      ],

      phoneCountryCodes:[
        { text:'Denmark (+45)', value: '+45' },
        { text:'Sweden (+46)', value: '+46' },
        { text:'Norway (+47)', value: '+47' },
        { text:'UK (+44)', value: '+44' },
        { text:'Finland (+358)', value: '+358' }
      ]
    }
  },
  methods: {
    openConfirmDeactivateUser() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure that you would like to deactivate the user?',
        accept: this.deactivateUser
      })
    },

    removeTag (item) {
      this.tags.splice(this.tags.indexOf(item), 1)
    },

    onChangeRole: function (roleId) {
      this.user.role = roleId;

      this.updateUserRole(roleId);
    },

    updateUserRole: function (role) {
      this.$vs.loading()

      this.$http.put(process.env.VUE_APP_API +'/users/role/' + this.user.userId + '/' + role)
          .then((/*resp*/) => {
            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Role changed'
            });
          })
          .catch(err => {
            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could change role:' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },

    getUser: function (userId) {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/users/' + userId)
          .then(resp => {
            this.user = resp.data;

            if (this.user.tags) {
              this.tags = this.user.tags;
            } else {
              this.tags = [];
            }
          })
          .catch(err => {
            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not fetch user:' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },

    activateUser: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#toggle-activate-user-button",
        scale: 0.45
      });

      this.$http.post(process.env.VUE_APP_API +'/users/invites/' + this.user.userId)
          .then((/*resp*/) => {
            this.user.isDeactivated = false;

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'User activated'
            })
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not send activate User'
            });
          })
          .finally(() => {
            this.$vs.loading.close("#toggle-activate-user-button > .con-vs-loading")
          })
    },

    deactivateUser: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#toggle-deactivate-user-button",
        scale: 0.45
      });

      this.$http.delete(process.env.VUE_APP_API +'/users/' + this.user.userId)
          .then((/*resp*/) => {
            this.user.isDeactivated = true;

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'User deactivated'
            })
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not send deactivate User'
            });
          })
          .finally(() => {
            this.$vs.loading.close("#toggle-deactivate-user-button > .con-vs-loading")
          })
    },

    saveInfo: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      });

      const payload = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        ssn: this.user.ssn,
        email: this.user.email,
        phone: this.user.phone,
        phoneCountryCode: this.user.phoneCountryCode,
        jobTitle: this.user.jobTitle,
        tags: this.tags
      };

      this.$http.put(process.env.VUE_APP_API +'/user/' + this.user.userId + '/info/general', payload)
          .then(resp => {
            console.log(resp.data);

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Info updated'
            })
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not update info'
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    }
  },
  created() {
    this.getUser(this.$route.params.userId);
  }
}
</script>

<style lang="scss" scoped>
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.con-chips--remove-all {
  display: none;
}

</style>